import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { wwThemeExtension } from './wwThemeExtension';

/** Frontend module that registers the wibblewabble app theme. */
export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [wwThemeExtension],
});
